export default __webpack_public_path__ + "static/media/Roboto-CondensedItalic.9e2c1759.ttf";